import { connect, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { Dialog } from 'antd-mobile-v5'
import { push } from 'connected-react-router';
import React from 'react';
import { localizeResource } from '../../services/utilities';
import { getCookie } from '../../components/common/cookie';

import './Campaign.css';
import { useHistory } from 'react-router-dom';
import HaiHangLink from '../../components/HaiHangLink';
import { useHasLogin } from '../../services/hooks';

const CampaignPage = () => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const { data } = useHasLogin({
    manual: false
  });

  const { activityList, activity } = useSelector((state) => ({
    activity: state.ui.activityList,
    activityList: state.ui.activityList.activityListItemDTOS,
  }));

  const language = getCookie('language');
  const questionnaireImg = localizeResource('questionnaire.jpg', language);
  const newYearImg = localizeResource('new-year.jpg', language);

  const showWenjuan = () => {
    Dialog.show({
      title: formatMessage({ id: 'questionaire-title' }),
      content:
        formatMessage(
          { id: 'questionaire-message' },
          { course: formatMessage({ id: `questionaire-course-${data.wenJuan.type}` }) },
        ),
      showCloseButton: true,
      closeOnAction: true,
      actions: [[
        {
          key: 'cancel',
          text: formatMessage({ id: 'common-cancel' }),
        },
        {
          key: 'open',
          bold: true,
          text: formatMessage({ id: 'common-confirm' }),
          primary: true,
          onClick: () => {
            window.location.href = data.wenJuan.url
          }
        },]
      ],
    });
  }

  const getCouponItem = (type) => {
    return activityList.find((activity) => activity.type === type)
  }

  const mailToBestDive = () => {
    const encodedSubject = encodeURIComponent("PADI 会员更新优惠订购");
    const mailtoLink = `mailto:marketing@bestdive.com?subject=${encodedSubject}`
    window.location.href = mailtoLink;
  }

  if (Object.keys(activity).length <= 0) return null;
  return <>
    <div className="campaign-list">
      {activityList && <>
        {getCouponItem('REGULATOR_COUPON') && (
          <div onClick={() => history.push('/regulator_coupon')}>
            <img
              src={`https://ecards-img.oss-cn-shenzhen.aliyuncs.com/equipment-coupon/scubapro_${language}.jpg`}
              alt="REGULATOR_COUPON"
            />
          </div>
        )}
        {getCouponItem('SUUNTO_COUPON') && (
          <div onClick={() => window.location.href = "https://static.suunto.cn/padi/"}>
            <img
              src="https://ecards-img.oss-cn-shenzhen.aliyuncs.com/equipment-coupon/suunto.jpg"
              alt="SUUNTO_COUPON"
            />
          </div>
        )}
        {getCouponItem('BESTDIVE_COUPON') && (
          <div onClick={mailToBestDive}>
            <img
              src="https://ecards-img.oss-cn-shenzhen.aliyuncs.com/equipment-coupon/bestdive.jpg"
              alt="BESTDIVE_COUPON"
            />
          </div>
        )}
      </>}
      <div>
        <HaiHangLink>
          <img
            style={{ width: "calc(100% - 10px)" }}
            src="https://assets.padi.com.cn/hnac.jpg"
            alt="hai hang"
          />
        </HaiHangLink>
      </div>
      <div onClick={() => history.push('/buy_cards')}>
        <img
          src={require(`../../assets/images/campaign/campaignPage/cards.jpg`)}
          alt="gear"
        />
      </div>
      {data && data.wenJuan.type && (
        <div onClick={() => showWenjuan()}>
          <img
            src={`https://assets.padi.com.cn/assets/images/campaign/campaignPage/${questionnaireImg}`}
            alt="questionnaire"
          />
        </div>
      )}
      <div onClick={() => history.push('/newYearCampaignPost')}>
        <img
          src={require(`../../assets/images/campaign/campaignPage/${newYearImg}`)}
          alt="gear"
        />
      </div>
    </div>
    <p className="campaign-footer">
      <FormattedMessage id="campaign-more" />
    </p>
  </>
};

export default connect(null, { push })(CampaignPage);
